import { Map } from 'immutable';
import actionTypes from '../../actions/actionTypes';

const INIT_STATE = Map({
    isConnectedFast: 'init'
})

function setIsConnectedFast(state, action){
    return state.set('isConnectedFast', action.payload.isConnectedFast);
}

export default function connectionReducer(state = INIT_STATE, action) {
    if(action === undefined){
        return state;
    }

    switch(action.type){
        case actionTypes.UI_SET_IS_CONNECTED_FAST:
            return setIsConnectedFast(state, action);
        default:
            return state;
    }
}
